import apiClient from "../lib/apiClient";

export interface HarvestConfigDto {
  sourceUrl: string;
  enabled?: boolean;
  importAsPaid?: boolean;
}

export interface HarvestConfigResponse {
  id: string;
  tenantId: string;
  sourceUrl: string;
  enabled: boolean;
  importAsPaid: boolean;
  lastRunAt?: string | null;
  lastRunSummary?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface HarvestRunResponse {
  circuitsProcessed: number;
  parcoursCreated: number;
  parcoursUpdated: number;
  artistsCreated: number;
  artistsUpdated: number;
  lieuxCreated: number;
  lieuxUpdated: number;
  dryRun: boolean;
  createdParcoursIds: string[];
  errors: string[];
}

export async function getHarvestConfig() {
  const { data } = await apiClient.get<HarvestConfigResponse | "">("/harvest/config");
  return data === "" ? null : data;
}

export async function saveHarvestConfig(dto: HarvestConfigDto) {
  const { data } = await apiClient.put<HarvestConfigResponse>("/harvest/config", dto);
  return data;
}

export async function deleteHarvestConfig() {
  await apiClient.delete("/harvest/config");
}

export async function runHarvestNow(dryRun: boolean) {
  const { data } = await apiClient.post<HarvestRunResponse>("/harvest/run", null, {
    params: { dryRun },
  });
  return data;
}
